export default __webpack_public_path__ + "static/media/ies.a1c901c9.png";